/**
 * Validação de especialidade (LCMY_REG_MODELS_TEC) ao arrastar OS para coluna de técnico no Board.
 */

import { getApiBaseUrl } from '../../../utils/apiConfig';

export const BOARD_SPECIALTY_DRAG_MSG = 'O técnico não possui especialidade neste equipamento.';

/**
 * @param {string|null|undefined} technicianId - TB01024_CODIGO
 * @param {string[]} orderIds - TB02115_CODIGO
 * @returns {Promise<{ allowedOrderIds: string[], rejectedOrderIds: string[] }>}
 */
export async function validateBoardDragSpecialty(technicianId, orderIds) {
  const ids = Array.isArray(orderIds)
    ? orderIds.map((x) => String(x || '').trim()).filter(Boolean)
    : [];
  if (!technicianId || ids.length === 0) {
    return { allowedOrderIds: ids, rejectedOrderIds: [] };
  }
  const token = localStorage.getItem('authToken');
  try {
    const res = await fetch(`${getApiBaseUrl()}/api/team/validate-drag-specialty`, {
      method: 'POST',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ technicianId, orderIds: ids }),
    });
    const data = await res.json().catch(() => ({}));
    if (!data.success) {
      return { allowedOrderIds: ids, rejectedOrderIds: [] };
    }
    const rejected = new Set(
      (Array.isArray(data.rejectedOrderIds) ? data.rejectedOrderIds : [])
        .map((x) => String(x || '').trim())
        .filter(Boolean)
    );
    return {
      allowedOrderIds: ids.filter((id) => !rejected.has(id)),
      rejectedOrderIds: ids.filter((id) => rejected.has(id)),
    };
  } catch (_err) {
    return { allowedOrderIds: ids, rejectedOrderIds: [] };
  }
}
